// extracted by mini-css-extract-plugin
export default {"form":"reverse-value-form_form__m8NHj","row":"reverse-value-form_row__BHev6"};